import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepaidServicesComponent } from './prepaid-services.component';
import { SharedModule } from 'app/shared-module/shared/shared.module';
import { CardIntegrationModule } from 'app/services/date-time/card-integration/card-integration.module';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule } from '@angular/material';

const route: Routes = [
  {
    path: 'subscriptions',
    component: PrepaidServicesComponent
  }
]
@NgModule({
  declarations: [PrepaidServicesComponent],
  imports: [
    CommonModule,
    SharedModule,
    CardIntegrationModule,
    RouterModule.forChild(route),
    MatDialogModule
  ],
  exports: [PrepaidServicesComponent,RouterModule],
  // entryComponents: [PrepaidServicesComponent],
})
export class PrepaidServicesModule { }



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/prepaid-services/prepaid-services.module.ts